import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../src/styles/styles.css'

ReactDOM.render(<App />, document.getElementById('root'));
